import * as Yup from "yup";

export const addProductServiceSchema = Yup.object().shape({
  name: Yup.string().max(50, "Trop long!").required("Obligatoire"),
});
